import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/runner/_work/l-box-user-front/l-box-user-front/layouts/default.vue").then(m => m.default || m)),
  headerless: defineAsyncComponent(() => import("/runner/_work/l-box-user-front/l-box-user-front/layouts/headerless.vue").then(m => m.default || m))
}